import { FC } from 'react';

// Components
import DropdownButton from './Dropdown/DropdownButton';
import { DropdownMenu } from './Dropdown/DropdownMenu';

// Utils
import { isMobileUserAgent, classNames } from '@sportal365/smp-widget-utils';
import useDetectClickOutside from '../../../../../packages/hooks/useDetectClickOutside';

// Types
import { IRounds, IStage } from '../../../../../packages/types';

interface Props {
  currentStage?: IStage;
  currentRound?: { label: string; value: string };
  rounds: IRounds[];
  setRound: (value: string) => void;
  setStage: (value: string) => void;
}

const RoundDropdown: FC<Props> = ({ currentStage, currentRound, rounds, setRound, setStage }) => {
  const isMobile = isMobileUserAgent();
  const hasMultipleStages = rounds.map((el) => el.stage).length > 1;

  const { isComponentVisible, setIsComponentVisible, ref } = useDetectClickOutside<HTMLDivElement>();

  const handleMenuOpen = () => setIsComponentVisible(!isComponentVisible);

  return (
    <div ref={ref} className='dropdown-container relative w-full sm:w-[215px]'>
      {isComponentVisible && isMobile && (
        <div
          className={classNames({
            'fixed inset-0 w-lvw h-lvh bg-[#00000099] z-10 opacity-0 transition-opacity duration-500 ease-out': true,
            'opacity-75': isComponentVisible,
          })}
          onClick={handleMenuOpen}
        />
      )}
      <DropdownButton
        isMenuOpen={isComponentVisible ?? false}
        handleMenuOpen={handleMenuOpen}
        round={currentRound?.label}
        stage={currentStage?.name}
        hasMultipleStages={hasMultipleStages}
      />
      {isComponentVisible ? (
        <DropdownMenu
          isMobile={isMobile}
          options={rounds}
          currentRound={currentRound}
          currentStage={currentStage}
          setRound={setRound}
          setStage={setStage}
        />
      ) : null}
    </div>
  );
};

export default RoundDropdown;
